import * as React from 'react';

import SVGBase from '../svg-base/svg-base';

export interface NewReleaseAllProductsProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const NewReleaseAllProducts: React.FunctionComponent<React.PropsWithChildren<NewReleaseAllProductsProps>> = ({
    fill,
    title,
    height,
    width,
    ...rest
}: NewReleaseAllProductsProps) => (
    <SVGBase viewBox="0 0 50 56.05" height={height} width={width} title={title} fill={fill} {...rest}>
        <path
            fill="#ffd940"
            d="M38.63,39.17a8.38,8.38,0,0,1,5.41,2c.39-.46.77-.93,1.13-1.42L35.9,34.2A14.29,14.29,0,0,1,14.2,34L4.54,39.3A25.08,25.08,0,0,0,25.38,49.93a25.6,25.6,0,0,0,5-.58,8.45,8.45,0,0,1,8.26-10.18Z"
        />
        <path
            fill="#40c5ff"
            d="M10.87,24.78A14.29,14.29,0,0,1,23.06,10.65V0c-.32,0-.62.05-.93.09A25,25,0,0,0,0,25.3a23.45,23.45,0,0,0,.3,3.48,25,25,0,0,0,2.12,6.89L12,30.37A14.24,14.24,0,0,1,10.87,24.78Z"
        />
        <path
            fill="#40d98c"
            d="M49.84,22.09a24.77,24.77,0,0,0-2.69-8.78A25,25,0,0,0,31.53.79l-.16,0A23.4,23.4,0,0,0,27.26,0V10.65A14.29,14.29,0,0,1,39.38,23.58q.06.6.06,1.2c0,.19,0,.36,0,.54a14.37,14.37,0,0,1-.5,3.29,14.59,14.59,0,0,1-.65,1.82l-.09.23h0l9.17,5.46a24.4,24.4,0,0,0,1.5-3.71,2.76,2.76,0,0,0,.08-.27,25.41,25.41,0,0,0,.87-4.09A24.87,24.87,0,0,0,50,25.17v-.62c0-.65,0-1.3-.1-1.94Z"
        />
        <path fill="#ebadff" d="M44,41.13a8.44,8.44,0,1,0,3,6.48A8.38,8.38,0,0,0,44,41.13Z" />
    </SVGBase>
);

export default NewReleaseAllProducts;
